<template>
  <div class="booking-add-ons-form__date-without-interval">
    <ul class="form">
      <li
        v-for="(option, index) in options"
        :key="index"
        class="option"
      >
        <input
          :id="option.startTime"
          name="preferred-date"
          :type="addOn.singleSelectDatePicker ? 'radio' : 'checkbox'"
          :value="option.startTime"
          :checked="selectedAddOnDates.includes(option.startTime)"
          :aria-label="getDay(option.startTime)"
          @change="updateSelectedDates(option.startTime)"
        >
        <label :for="option.startTime">
          <div class="add-on-card-button-container">
            <span class="icon-clock" />
            <span class="label-text">{{ getDay(option.startTime) }}</span>
            <span class="icon-checkmark-gold" />
          </div>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getDate } from '@utils/date-helpers'

  export default {
    name: 'DateWithoutInterval',
    props: {
      addOn: {
        type: Object,
        required: true
      },
      data: {
        type: Object,
        default: () => {}
      }
    },
    data: () => ({
      selectedAddOnDates: []
    }),
    computed: {
      ...mapGetters('booking', ['selectedHotel']),
      ...mapGetters('i18n', ['tc']),
      dateOptionFormat() {
        return 'dddd[,] MMM[.] D'
      },
      isValid() {
        return !!this.selectedAddOnDates.length
      },
      options() {
        return this.addOn.availableDates
      }
    },
    watch: {
      isValid(val) {
        this.$emit('is-valid', val)
        this.$emit('input', this.$data)
      }
    },
    mounted() {
      if (this.data && this.data.selectedAddOnDates) {
        this.selectedAddOnDates = this.data.selectedAddOnDates.map((date) => date.endsWith('Z') ? date.slice(0, -1) : date)
      }
      this.$emit('input', this.$data)
    },
    methods: {
      getDay(day) {
        return getDate(day).format(this.dateOptionFormat)
      },
      updateSelectedDates(date) {
        if (this.addOn.singleSelectDatePicker) {
          this.selectedAddOnDates = [date]
        } else {
          const index = this.selectedAddOnDates.indexOf(date)
          if (index >= 0) {
            this.selectedAddOnDates = this.selectedAddOnDates.filter((item) => item !== date)
          } else {
            this.selectedAddOnDates = [...this.selectedAddOnDates, date]
          }
        }
      }
    }
  }
</script>
